import React, { useState } from "react";
import { Form, Field } from "react-final-form";
import { Message } from "primereact/message";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Card } from "primereact/card";
import { useNavigate } from "react-router-dom";
import { classNames } from "primereact/utils";
import { useLocation, useParams } from "react-router-dom";
import { useQuery } from "react-query";
import "./MotDePasseOublie.css";
import { ResetPassword, verifToken } from "../../Data/user_service";
import { ProgressSpinner } from "primereact/progressspinner";

export const ResetPasswordDisconnected = () => {
    const navigate = useNavigate();
    const [Load, setLoad] = useState(false);
    const [passwordCriteria, setPasswordCriteria] = useState({
        length: false,
        uppercase: false,
        lowercase: false,
        number: false,
        specialChar: false,
        match: false,
    });

    const search = useLocation().search;
    const email = new URLSearchParams(search).get("email");
    const { utilisateurId, token } = useParams();


    const content = (
        <div className="ml-2">
            ERREUR | Ce lien a expiré. Vous allez être redirigé vers notre site. ...
        </div>
    );

    const { isLoading, isError } = useQuery("verificationToken", () => verifToken(utilisateurId, token), {
        onError(error) {
            if (error.response?.status === 498) {
                setTimeout(() => {
                    navigate("/");
                }, 4000);
            }
        },
    });

    if (isLoading) {
        return (
            <div>
                <center>
                    <ProgressSpinner />
                </center>
            </div>
        );
    }
    if (isError) {
        return (
            <div>
                <div style={{ height: "100vh" }}>
                    <Message severity="error" className="border-primary w-full justify-content-center" content={content} />
                </div>
            </div>
        );
    }

    // Update password criteria based on input
    const updatePasswordCriteria = (password, confirmPassword) => {
        const criteria = {
            length: password.length >= 6,
            uppercase: /[A-Z]/.test(password),
            lowercase: /[a-z]/.test(password),
            number: /\d/.test(password),
            specialChar: /[@$!%*?&]/.test(password),
        };
        setPasswordCriteria(criteria);
    };

    const onSubmit = async (data) => {
        
        ResetPassword({
            id_utilisateur_gexonline: utilisateurId.toString(),
            token: token.toString(),
            password: data.password,
            confirmPassword: data.confirmPassword,
        })
            .then(() => {
                setLoad(true);
                setTimeout(() => {
                    navigate("/");
                }, 3000);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const validate = (data) => {
        let errors = {};
        if (!data.password) {
            errors.password = "Mot de passe requis.";
        }
        if (!data.confirmPassword) {
            errors.confirmPassword = "Confirmation du mot de passe requise.";
        } else if (data.confirmPassword !== data.password) {
            errors.confirmPassword = "Les mots de passe ne correspondent pas.";
        }
        return errors;
    };

    const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
    const getFormErrorMessage = (meta) => {
        return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
    };

    return (
        <div className="grid loginPage">
            <div className="login">
                <p className="presentation lg:col-2 lg:col-offset-2">
                    GexOnline est l'offre digitale du Groupe{" "}
                    <a href="https://gexpertise.fr" target="_blank" rel="noopener noreferrer" className="LinkGex">
                        GEXPERTISE
                    </a>{" "}
                    pour une information immobilière connectée proposant une interface simple et personnalisée. Retrouvez tous vos livrables en quelques clics.
                </p>

                <Card className="lg:col-2 lg:col-offset-1 cardLogin1">
                    {!Load ? (
                        <div className="cardMotdepasse">
                            <Form
                                onSubmit={onSubmit}
                                initialValues={{ email: email, password: "", confirmPassword: "" }}
                                validate={validate}
                                render={({ handleSubmit, values }) => (
                                    <form onSubmit={handleSubmit} className="p-fluid">
                                        <Field name="email" render={({ input, meta }) => (
                                            <div className="p-field">
                                                <span className="p-float-label p-input-icon-right">
                                                    <InputText {...input} disabled />
                                                    <label htmlFor="email">Adresse mail</label>
                                                </span>
                                            </div>
                                        )} />
                                        <Field
                                            name="password"
                                            render={({ input, meta }) => (
                                                <div className="p-field">
                                                    <span className="p-float-label p-input-icon-right">
                                                        <Password
                                                            id="password"
                                                            {...input}
                                                            feedback={false} // Feedback for visual indication
                                                            onInput={(e) => updatePasswordCriteria(e.target.value)}
                                                            toggleMask
                                                            className={classNames({
                                                                "p-invalid": isFormFieldValid(meta),
                                                            })}
                                                        />
                                                    <label htmlFor="password" className={classNames({ "p-error": isFormFieldValid(meta) })}>
                                                        Mot de passe*
                                                    </label>
                                                </span>
                                                {getFormErrorMessage(meta)}
                                            </div>
                                        )} />
                                        <Field name="confirmPassword" render={({ input, meta }) => (
                                            <div className="p-field" style={{ marginBottom: "20px" }}>
                                                <span className="p-float-label p-input-icon-right">
                                                    <Password
                                                        id="confirmPassword"
                                                        {...input}
                                                        feedback={false}
                                                        toggleMask
                                                        className={classNames({ "p-invalid": isFormFieldValid(meta) })}
                                                    />
                                                    <label htmlFor="confirmPassword" className={classNames({ "p-error": isFormFieldValid(meta) })}>
                                                        Confirmation de mot de passe*
                                                    </label>
                                                </span>
                                                {getFormErrorMessage(meta)}
                                            </div>
                                        )} />

                                        {/* Criteria for password strength */}
                                        <ul className="password-criteria" style={{ fontSize: "0.85rem" }}>
                                            <li style={{ color: passwordCriteria.length ? "green" : "red" }}>{passwordCriteria.length ? "✓" : "✗"} Le mot de passe contient au moins 6 caractères</li>
                                            <li style={{ color: passwordCriteria.specialChar ? "green" : "red" }}>{passwordCriteria.specialChar ? "✓" : "✗"} Le mot de passe contient un caractère spécial</li>
                                            <li style={{ color: passwordCriteria.number ? "green" : "red" }}>{passwordCriteria.number ? "✓" : "✗"} Le mot de passe contient un chiffre</li>
                                            <li style={{ color: passwordCriteria.uppercase ? "green" : "red" }}>{passwordCriteria.uppercase ? "✓" : "✗"} Le mot de passe contient une majuscule</li>
                                            <li style={{ color: passwordCriteria.lowercase ? "green" : "red" }}>{passwordCriteria.lowercase ? "✓" : "✗"} Le mot de passe contient une minuscule</li>
                                        </ul>

                                        <Button type="submit" label="Réinitialiser" className="p-mt-2 connect" />
                                    </form>
                                )}
                            />
                        </div>
                    ) : (
                        <div className="cardMotdepasse">
                            <p style={{ paddingTop: "20%", textAlign: "center", lineHeight: "30px" }}>
                                Votre mot de passe a bien été modifié.<br />
                                Vous allez être redirigé vers l'écran de connexion.
                            </p>
                        </div>
                    )}
                </Card>
            </div>
        </div>
    );
};
